import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"filter\"><path fill=\"currentColor\" d=\"M2 4h16v.8H2zM5 10h10v.8H5zM8 16h4v.8H8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol